var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTicketStateLostIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon ticket-state-lost-icon",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 13,
    fill: "#e0272a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.95 7.05a1 1 0 010 1.414L13.414 12l3.536 3.537a1 1 0 01-1.414 1.414L12 13.413 8.464 16.95a1 1 0 01-1.414-1.414l3.536-3.537L7.05 8.464A1 1 0 018.464 7.05L12 10.584l3.536-3.534a1 1 0 011.414 0z"
  }))));
}

export default SvgTicketStateLostIconSv;